import React, { Children, Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon, { ICON_NAMES } from 'components/Icon';

class Dropbox extends Component {
  static getDerivedStateFromProps = (props, state) => {
    const { visible, preview, children } = props;
    const overflow = preview > 0 && Children.count(children) > preview;

    if (!state.initialized) return ({
      initialized: true,
      visible: visible,
      overflow: overflow,
      more: overflow
    });

    return null;
  }
  constructor(props) {
    super(props);

    this.state = {
      initialized: false,
      overflow: null,
      visible: null,
      more: null,
    };
  }

  handleToggle = () => {
    const { locked } = this.props;
    if (!locked) {
      this.setState(({ visible, overflow }) => ({
        visible: !visible,
        more: overflow
      }));
    }
  }

  handleMore = () => {
    this.setState(({ more }) => ({
      more: !more
    }));
  }

  render() {
    const { title, preview, children, isBordered, forForm, locked, titleSize, hashId } = this.props;
    const { overflow, more, visible } = this.state;

    return (
      <div id={hashId} className={classNames("dropbox", { "dropbox--active": visible })}>
        <button
          type="button"
          onClick={this.handleToggle}
          className="dropbox__header">
          <h6 className={classNames("dropbox__title", {
            "dropbox__title-sm": titleSize === "sm"
          })}>{title}</h6>

          {
            locked &&
            <span className="dropbox__pay">pay<br />
              to unlock</span>
          }
          <Icon
            name={visible ? ICON_NAMES.minus : ICON_NAMES.plus}
            className="dropbox__icon"
          />
        </button>
        {
          isBordered &&
          <div className="dropbox__border-container">
            <div className="dropbox__border"></div>
          </div>
        }

        {
          !locked &&
          <div className={classNames("dropbox__content", {
            "dropbox__content--form": forForm,
            "dropbox__content--active": visible,
          })}>
            {more ? Children.map(children, (child, index) => {
              if (index >= preview) return null;

              return React.cloneElement(child);
            }) : children}

            {!overflow ? null : (
              <button
                onClick={this.handleMore}
                className="dropbox__more"
                type="button"
              >
                {more ? "Show more" : "Hide"}
              </button>
            )}
          </div>
        }
      </div>
    );
  }
}

Dropbox.defaultProps = {
  visible: true,
  isBordered: false,
  forForm: false,
  locked: false,
  titleSize: 'lg',
}

Dropbox.propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool,
  preview: PropTypes.number,
  isBordered: PropTypes.bool,
  forForm: PropTypes.bool,
  locked: PropTypes.bool,
  titleSize: PropTypes.oneOf(['sm', 'lg']),
}

export default Dropbox;